import React from 'react';
import TopBar from './components/TopBar';
import UserNameForm from './components/UserNameForm';
import BirthForm from './components/BirthForm';
import PasswordForm from './components/PasswordForm';
import SmsCodeForm from './components/SmsCodeForm';
import texts from './texts/forms';
import UserAPI from './api/UserAPI';
import StatusMessage from './components/StatusMessage';
import MainMessage from './components/MainMessage';
import { isEmpty } from 'lodash';


export default class App extends React.Component {

  constructor(props) {
    super(props);

    this.onUserNameFormSubmit = this.onUserNameFormSubmit.bind(this);
    this.onBirthFormSubmit = this.onBirthFormSubmit.bind(this);
    this.onPasswordFormSubmit = this.onPasswordFormSubmit.bind(this);
    this.onSmsCodeFormSubmit = this.onSmsCodeFormSubmit.bind(this);

    this.state = {
      language: 'CZ',
      statusCode: 0,
      tokenSign: '',
      responseMap: '',
      username: ''
    };
  }

  onFlagClick(lang) {
    this.setState({language: lang});
  }

  onUserNameFormSubmit(value) {
      //this.setState({statusCode: 600});
    UserAPI.sendUserName(value, this.state.tokenSign).then(function (res){
      if (!isEmpty(res.map)) {
        this.setState({responseMap: res.map});
      }
      this.setState({statusCode: res.status.statusCode});
    }.bind(this));
    }


  onBirthFormSubmit(value) {
   //   this.setState({statusCode: 700});
        UserAPI.sendBirth(value, this.state.tokenSign, this.state.responseMap.tokenForRC)
          .then(function (res){
              if (!isEmpty(res.map)) {
                this.setState({responseMap: res.map});
              }
              this.setState({statusCode: res.status.statusCode});
        }.bind(this));
  }

    onSmsCodeFormSubmit(value) {
        //this.setState({statusCode: 800});

        UserAPI.sendSmsCode(value, this.state.tokenSign, this.state.responseMap.tokenForSMS)
            .then(function (res){
                if (!isEmpty(res.map)) {
                    this.setState({responseMap: res.map});
                }
                this.setState({statusCode: res.status.statusCode});
            }.bind(this));

  }

  onPasswordFormSubmit(value) {
        UserAPI.changePassword(value, this.state.tokenSign, this.state.responseMap.tokenForPassword)
          .then(function (res){
              if (!isEmpty(res.map)) {
                this.setState({
                  responseMap: res.map
                });
              }
              this.setState({statusCode: res.status.statusCode});
        }.bind(this));

  }

  onPasswordFormValidate(value) {
      //console.log("VALIDATE : ", value);
      //this.setState({statusCode: res.status.statusCode});
      UserAPI.validatePassword(value, this.state.tokenSign, this.state.responseMap.tokenForPassword)
      .then(function (res){
          if (!isEmpty(res.map)) {
            this.setState({responseMap: res.map});
          }
          this.setState({statusCode: res.status.statusCode});
    }.bind(this));

  }

  /*
  * Metoda pro získání podpisového tokenu
  * DEVEL - o token žádá přímo JS aplikace
  * PROD - o token žádá php skript (kvůli ip adrese) 
  */
  componentDidMount() {
    let tokenElem = document.getElementById('token');
    this.setState({tokenSign: tokenElem.dataset.token});
    //devel only
    if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
      UserAPI.sendClientTicket(tokenElem.dataset.token).then(function (res){
        console.log('FIRST RES', res);
        this.setState({statusCode: res.status.statusCode});
      }.bind(this));
    }    
  }

  dispatchForm(statusCode) {
    let dispatcher = {
          0: 1,// waiting for the first action
        100: 1,//'ticket přijat a je OK',
        101: 1,//'ticket přijat z nepovolené IP adresy',
        102: 1,//'ticket je příliš krátký ',
        103: 1,//'neexistující komunikační tiket klienta',
        200: 2,//'GUID v pořádku přijat',
        201: 1,//'GUID neexistuje',
        202: 1,//'IP uzamčena ',
        203: 1,//'GUID je v pořádku, ale účet v LIANE ještě nebyl vytvořen',
        204: 1,//'GUID již byl jednou použit',
        300: 3,//'RČ v pořádku ověřeno',
        301: 1,//'Token pro ověření RČ neexistuje nebo vypršela jeho platnost',
        302: 1,//'Token pro ověření RČ je vázán na neexistující GUID nebo již použité GUID',
        303: 2,//'chyba ověření RČ',
        400: 5,//'Heslo vytvořeno',
        401: 1,//'Token pro vytvoření hesla neexistuje nebo vypršela jeho platnost',
        402: 1,//'Token pro vytvoření hesla je vázán na neexistující GUID nebo již použité GUID',
        403: 4,//'Heslo se nepodařilo změnit - chyba LDAP apod ..'
        410: 4,//'Formát hesla je v pořádku',
        411: 4,//'Minimální délka hesla je 8 znaků',
        412: 4,//'Heslo musí obsahovat min. jednu číslici',
        413: 4,//'Heslo musí obsahovat min. jeden alfanumerický znak',
        414: 4,//'Heslo obsahuje nepovolené znaky',
        415: 4,//'Heslo nesmí být stejné jako heslo pro vzdálený přístup',
        416: 4,//'Heslo nesmí obsahovat rodné číslo, jméno, příjmení a blokované fráze a to ani pozpátku'
        600: 2,// Uživatel v pořádku ověřen
        601: 1,// Neexistující uživatel
        602: 1,// Uživatel má zablokovaný účet.
        603: 1,// Uživatel nemá registrované mobilní číslo
        604: 1,// Uzamčená IP uživatele
        700: 3,//'Ověření RC proběhlo v pořádku, na mobilní telefon byl zaslán ověřovací kód',
        701: 1,//'Ověření RC proběhlo v pořádku, nebyl nalezen registrovaný telefon',
        702: 1,//'Ověření RC proběhlo v pořádku, při odeslání SMS se vyskytla chyba.',
        803: 1,// Pro tohoto uživatele je služba zasílání SMS momentálně uzamčena,
        800: 4,//Ověření proběhlo v pořádku, je možno zaslat nové heslo
        801: 1,//Token pro ověření SMS kódu neexistuje nebo vypršela jeho platnost
        802: 3//SMS kód neodpovídá zaslanému kódu


    };

    return dispatcher[statusCode];
  }

  render() {


        let formText = texts[this.state.language];
        let statNr = this.dispatchForm(this.state.statusCode);
        let canSubmit = this.state.statusCode === 410;
        let formTitle = formText['step'+statNr];
        let forms = {
          1: <UserNameForm texts={formText} handleSubmit={this.onUserNameFormSubmit} />,
          2: <BirthForm texts={formText} handleSubmit={this.onBirthFormSubmit} />,
          3: <SmsCodeForm texts={formText} handleSubmit={this.onSmsCodeFormSubmit} />,
          4: <PasswordForm texts={formText} handleSubmit={this.onPasswordFormSubmit}
                             lang={this.state.language}
                             validatePassword={this.onPasswordFormValidate.bind(this)}
                             canSubmit={canSubmit} />
        };

        //debug
        if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
            console.log("STAT NUMBER : ", statNr);
            console.log("STATUS CODE : ", this.state.statusCode);
            console.log("TITLE : ", formTitle);
        }
        
        return (
          <div className="container">
            <TopBar title={formText.title} onClick={this.onFlagClick.bind(this)} />
            <div className="col-md-6 col-md-offset-3">
              <h2>{formTitle}</h2>
              <MainMessage lang={this.state.language} stateCode={statNr} />
              {forms[statNr]}
              <StatusMessage lang={this.state.language} statusCode={this.state.statusCode} />
            </div>
          </div>
    );
  }
}
